import * as React from 'react'
import { useId } from 'react'

import { computeSize } from '../shared'
import type { IconProps } from '../shared'

/**
 * Instagram carousel arrow left icon with circular background and drop shadow.
 */
const ArrowLeftIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 'medium', className, ...props }, ref) => {
    const computedSize = computeSize(size)
    const filterId = useId()

    return (
      <svg
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <g filter={`url(#${filterId})`}>
          <path
            d="M15 1C8.37259 1 3.00002 6.3726 3 13C3 19.6274 8.37258 25 15 25C21.6274 25 27 19.6274 27 13C27 6.3726 21.6274 1 15 1ZM18.375 9.03906L14.2754 13.1377L18.375 17.2383L16.6074 19.0059L10.7393 13.1377L16.6074 7.27148L18.375 9.03906Z"
            fill="white"
            fillOpacity="0.8"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id={filterId}
            x="0"
            y="0"
            width="30"
            height="30"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2681_41929"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2681_41929"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  },
)

ArrowLeftIcon.displayName = 'InstagramArrowLeftIcon'

export { ArrowLeftIcon }
